import { Tag, Text } from '@wework/dieter-ui'
import StatusTag, { SpaceStatus } from '../StatusTag'
import React from 'react'
import isPast from 'date-fns/isPast'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import CommitmentDates from './CommitmentDates'
import isSameMonth from 'date-fns/isSameMonth'
import addMonths from 'date-fns/addMonths'
import withConfiguration from '../../hoc/withConfiguration'

const DATE_FORMAT = {
  DATE: 'MMM dd, yyyy',
  datetime: 'MMM dd, yyyy HH:mm (xxx)',
}

function CommitmentItem({
  reservation,
  commitmentsFetchDelay = 0,
  configuration,
}: any) {
  const { account, startedOn, endedOn } = reservation
  const { spacestationBaseUrl } = configuration
  const dateLabel: string[] = []
  const dates: string[] = []

  let moIn = false
  let mimoText = ''
  if (startedOn) {
    dateLabel.push('Start')
    dates.push(format(parseISO(startedOn), DATE_FORMAT.DATE))

    if (isPast(parseISO(startedOn))) {
    }

    if (isSameMonth(new Date(startedOn), addMonths(new Date(), 1))) {
      mimoText = 'MI next month'
      moIn = true
    }
  }

  if (endedOn) {
    dateLabel.push('End')
    dates.push(format(parseISO(endedOn), DATE_FORMAT.DATE))

    const monthToday = new Date()
    const monthTodayFirstDay = new Date(
      monthToday.getFullYear(),
      monthToday.getMonth(),
      1
    )
    const monthTodayLastDay = new Date(
      monthToday.getFullYear(),
      monthToday.getMonth() + 1,
      0,
      23,
      59,
      59,
      999
    )

    const twoMonths = new Date()
    twoMonths.setMonth(monthToday.getMonth() + 1)
    const twoMonthsFirstDay = new Date(
      twoMonths.getFullYear(),
      twoMonths.getMonth(),
      1
    )
    const twoMonthsLastDay = new Date(
      twoMonths.getFullYear(),
      twoMonths.getMonth() + 1,
      0,
      23,
      59,
      59,
      999
    )

    const monthMO = new Date(endedOn)

    if (
      monthMO.getTime() >= monthTodayFirstDay.getTime() &&
      monthMO.getTime() <= monthTodayLastDay.getTime()
    ) {
      mimoText = 'MO this month'
    } else if (
      monthMO.getTime() >= twoMonthsFirstDay.getTime() &&
      monthMO.getTime() <= twoMonthsLastDay.getTime()
    ) {
      mimoText = 'MO next month'
    }
  }

  if (!account) {
    return null
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <StatusTag status={SpaceStatus.OCCUPIED} />
        {mimoText !== '' ? (
          <Tag color={moIn ? 'green' : 'red'} size="small">
            {mimoText}
          </Tag>
        ) : (
          ''
        )}
      </div>
      <Text
        size="medium"
        primary
        style={{ marginTop: 12, marginBottom: 2 }}
        as="a"
        target="_blank"
        href={`${spacestationBaseUrl}companies/${account.uuid}`}
      >
        {`${account.name}`}
      </Text>
      <Text size="tiny">{`${account.accountAdmin.firstName} ${account.accountAdmin.lastName}`}</Text>
      <CommitmentDates
        reservation={reservation}
        commitmentsFetchDelay={commitmentsFetchDelay}
      />
      <Text size="tiny" style={{ fontWeight: '600', marginTop: 18 }}>
        Move in/out
      </Text>
      <Text size="tiny">
        {dates[0]}- {dates[1] || 'TBD'}
      </Text>
    </div>
  )
}

export default withConfiguration()(CommitmentItem)
